import * as React from 'react';
import { useAccountDropdownBundle } from 'src/providers/PantherLocalizationProvider';
import { AccountFilteredMessage } from '../IA2AccountFilteredMessage';

type IA2CentricAccountFilteredMessage = {
  numAccounts: number;
};

export const CentricAccountFilteredMessage: React.FC<
  IA2CentricAccountFilteredMessage
> = ({ numAccounts }) => {
  const bundle = useAccountDropdownBundle();
  const message = bundle.formatMessage(
    'account-dropdown-filterd-accounts-display',
    {
      numAccounts: numAccounts,
    },
  );
  return <AccountFilteredMessage message={message} />;
};
